export default __webpack_public_path__ + "static/media/loading.242e70cd.gif";